import React from 'react';
import { canAccessCampaignsNav, canAccessResourcesNav, hasPermission } from '@/helpers/permissionValidator';
import routes from '@/config/routes';
import { Permission, PermissionLevel } from '@/constants/client/permission';
import { getCommonRoutes } from './commonRoutes';
import { PrivateRoute } from './PrivateRoute';

export const getClientRoutes = (): React.ReactElement[] => {
  const SU_Dashboard = React.lazy(() => import('@/pages/client/dashboard'));
  const SU_Resources = React.lazy(() => import('@/pages/client/resources'));
  const SU_Scheduling = React.lazy(() => import('@/pages/client/scheduling'));
  const SU_Contracts = React.lazy(() => import('@/pages/client/contracts'));
  const SU_Interviews = React.lazy(() => import('@/pages/client/interviews'));
  const SU_Campaigns = React.lazy(() => import('@/pages/client/campaigns'));
  const SU_Learn = React.lazy(() => import('@/pages/client/Learn'));
  const SU_Interviews_Score = React.lazy(() => import('@/pages/client/campaigns/interviewScore'));
  const SU_ClassDetails = React.lazy(() => import('@/pages/client/classDetails'));
  const SU_Notify = React.lazy(() => import('@/pages/client/communications/suNotify'));
  const Reports = React.lazy(() => import('@/pages/client/reports'));
  const SU_Community = React.lazy(() => import('@/pages/agent/community'));

  const result: React.ReactElement[] = [];

  getCommonRoutes().forEach(item => result.push(item));

  result.push(
    <PrivateRoute key={routes.client.dashboard.index} component={SU_Dashboard} path={routes.client.dashboard.index} />,
    <PrivateRoute key={routes.client.contracts.index} component={SU_Contracts} path={routes.client.contracts.index} />,
  );

  if (hasPermission(Permission.SCHEDULE, PermissionLevel.ANY)) {
    result.push(
      <PrivateRoute
        key={routes.client.scheduling.index}
        component={SU_Scheduling}
        path={routes.client.scheduling.index}
      />,
    );
  }

  if (canAccessResourcesNav()) {
    result.push(
      <PrivateRoute
        key={routes.client.resources.index}
        component={SU_Resources}
        path={routes.client.resources.index}
      />,
    );
  }

  if (canAccessCampaignsNav()) {
    result.push(
      <PrivateRoute
        exact
        key={routes.client.campaigns.index}
        component={SU_Campaigns}
        path={routes.client.campaigns.index}
      />,
    );
  }

  result.push(
    <PrivateRoute
      key={routes.client.campaignsNew.index}
      component={SU_Interviews}
      path={routes.client.campaignsNew.index}
    />,
  );

  if (hasPermission(Permission.TRAINING_CLASSES, PermissionLevel.ANY)) {
    result.push(
      <PrivateRoute exact key={routes.client.learn.index} component={SU_Learn} path={routes.client.learn.index} />,
    );
  }

  result.push(
    <PrivateRoute
      component={SU_Interviews_Score}
      key={routes.client.campaigns.interviewScore}
      path={routes.client.campaigns.interviewScore}
    />,
    <PrivateRoute
      exact
      key={routes.client.classId.index}
      component={SU_ClassDetails}
      path={routes.client.classId.index}
    />,
    <PrivateRoute
      key={routes.client.interviews.index}
      component={SU_Interviews}
      path={routes.client.interviews.index}
    />,
    <PrivateRoute key={routes.client.reports.index} component={Reports} path={routes.client.reports.index} />,
    <PrivateRoute
      key={routes.client.communications.notify}
      component={SU_Notify}
      path={routes.client.communications.notify}
    />,
    <PrivateRoute key={routes.client.reports.chatLog} component={Reports} path={routes.client.reports.chatLog} />,
    <PrivateRoute key={routes.client.community.index} path={routes.sp.community} component={SU_Community} />,
  );

  return result;
};
